import script from "./InfoEndedTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoEndedTasks.vue?vue&type=script&setup=true&lang=js"

import "./InfoEndedTasks.vue?vue&type=style&index=0&id=33741d45&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33741d45"]])

export default __exports__